import "./NotFound.css";

const NotFound = () => {
  return (
    <div className="container page-not-found">
      <h1>404</h1>
      <h2>Page not found</h2>
    </div>
  );
};

export default NotFound;
